import React, { useRef, SVGProps } from "react";
import useWindowDimensions from "hooks/useWindowDimension";
import { clsx } from "clsx";
import { Menu, PopoverProps } from "@mui/material";
import { PopOverMenuList } from "./PopOverMenuList";
import { SwipePopup } from "components/UI/SwipePopup";
import "./style/PopOverMenu.scss";

export interface IGroup {
  groupName: string | null;
  groupMobileName: string | null;
  items: IItem[];
}

export interface IItem {
  title: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  onClick: () => void;
  disabled?: boolean;
}

interface IPopOverMenuProp {
  menuProps: Partial<PopoverProps>;
  isOpen: boolean;
  onClose: () => void;
  menuItems: IGroup[];
  className?: string;
  isFullscreen?: boolean;
  title?: string;
}

export const PopOverMenu = (props: IPopOverMenuProp) => {
  const { isOpen, onClose, menuItems, menuProps, className, isFullscreen, title } = props;
  const fullScreenMenuRef = useRef(null);
  const isDesktop = useWindowDimensions();
  const classes = clsx(["PopOverMenu", isFullscreen && "PopOverMenu_isFullScreen", className]);

  const closeFullScreenMenu = (e: React.MouseEvent) => {
    if (fullScreenMenuRef.current === e.target) {
      onClose();
    }
  };

  return (
    <div
      className={classes}
      ref={fullScreenMenuRef}
      onClick={closeFullScreenMenu}
    >
      {!isDesktop ? (
        <SwipePopup
          isOpen={isOpen}
          onClose={onClose}
          title={title}
        >
          <div className="MoreMenuPopupCnt">
            {menuItems.map((group: IGroup, index: number) => (
              <PopOverMenuList {...group} key={index}/>
            ))}
          </div>
        </SwipePopup>
      ) : (
        <Menu
          className="PopOverMenu"
          open={isOpen}
          onClose={onClose}
          {...menuProps}
        >
          <div className="MoreMenuCnt">
            {menuItems.map((group: IGroup, index: number) => (
              <PopOverMenuList {...group} key={index}/>
            ))}
          </div>
        </Menu>
      )}
    </div>
  );
};
